export class IEventPresenter {
    id: number;
    eventId: number;
    vaUserId: string;
}